import {
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useState,
  ReactNode,
} from "react";
import useUpdateNode from "../../hooks/useUpdateNode";
import { isValidHex } from "../../utils/isValidHex";

type HexInputProps = {
  id: string;
  color: string;
  children: (inputProps: {
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onBlur: () => void;
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => void;
    maxLength: number;
  }) => ReactNode;
};

export function HexInput({ id, color, children }: HexInputProps) {
  const [inputColorNoHash, setInputColorNoHash] = useState(color.substring(1));
  const updateNodeAndSave = useUpdateNode();

  const handleColorChange = (color: string) => {
    updateNodeAndSave({
      id,
      data: {
        color,
      },
    });
  };

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputColorNoHash(event.target.value);
  };

  const onBlurValidateColor = () => {
    if (isValidHex(inputColorNoHash)) {
      handleColorChange(`#${inputColorNoHash}`);
    }
  };

  const onKeyPressHandler = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" && isValidHex(inputColorNoHash)) {
      handleColorChange(`#${inputColorNoHash}`);
    }
  };

  useEffect(() => {
    setInputColorNoHash(color.substring(1));
  }, [color]);

  const inputProps = {
    value: inputColorNoHash.toUpperCase(),
    onChange: onInputChange,
    onBlur: onBlurValidateColor,
    onKeyDown: onKeyPressHandler,
    maxLength: 6,
  };

  return <>{children(inputProps)}</>;
}
